import React from 'react';
import { 
  Divider, 
  Grid, 
  Typography, 
  IconButton, 
  Box 
} from '@mui/material';
import {
  formatDate,
  formatMoney,
  getShortString,
} from '../../../../../../../../../../lib/functions/utils';
import { cellFormat } from '../../../../../../../../../../lib/designSystem/Table/cellFormat';
import { FileDownload as FileDownloadIcon } from '@mui/icons-material';

interface Props {
  request: any;
  onExport?: () => void;
}

const PayOutSummary = (props: Props) => {
  const { request, onExport } = props;

  console.log('request', request);

  const paid = request.payments.every((payment: any) => payment.executedAt);
  const hasCompletedPayments = request.payments.some((payment: any) => payment.executedAt);

  const divStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '12px 0px',
  };

  const DetailsSummary = () => (
    <div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Estado
        </Typography>
        <Typography variant="body1">{cellFormat(paid, 'paid')}</Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Cliente confirming
        </Typography>
        <Typography variant="body1">{request.stakeholderName}</Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Rut cliente confirming
        </Typography>
        <Typography variant="body1">{request.stakeholderIdentifier}</Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Fecha de solicitud
        </Typography>
        <Typography variant="body1">{formatDate(request.createdAt)}</Typography>
      </div>
    </div>
  );

  const AmountSummary = () => {
    const paymentsAmount = request.payments.reduce((acc: any, payment: any) => {
      return acc + payment.amount;
    }, 0);
    const groupedPayments = Object.values(
      request.payments.reduce((acc: any, curr: any) => {
        const id = curr.businessDestinationIdentifier;
        if (!acc[id]) {
          acc[id] = {
            businessIdentifier: id,
            businessName: curr.businessDestinationName,
            totalAmount: 0,
          };
        }
        acc[id].totalAmount += curr.amount;
        return acc;
      }, {}),
    );
    return (
      <div>
        <Typography fontWeight={600} variant="h6">
          Resumen Montos
        </Typography>
        {groupedPayments.map((payment: any) => (
          <div style={divStyle} key={payment.businessIdentifier}>
            <Typography fontWeight={600} variant="body1">
              {getShortString(payment.businessName, 30)}
            </Typography>
            <Typography variant="body1">
              {formatMoney(payment.totalAmount)}
            </Typography>
          </div>
        ))}
        <Divider />
        <div style={divStyle}>
          <Typography fontWeight={600} variant="body1">
            Total a pagar
          </Typography>
          <Typography variant="body1">{formatMoney(paymentsAmount)}</Typography>
        </div>
      </div>
    );
  };

  return (
    <div>
      {hasCompletedPayments && onExport && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <IconButton
            size="small"
            onClick={onExport}
            sx={{
              color: 'primary.main',
              backgroundColor: 'grey.50',
              border: '1px solid',
              borderColor: 'grey.200',
              '&:hover': {
                backgroundColor: 'grey.100',
                borderColor: 'grey.300',
              },
              borderRadius: '100px',
              padding: '4px 12px',
            }}
          >
            <FileDownloadIcon sx={{ fontSize: '1rem', paddingRight: '4px' }} />
            <Typography variant="caption" fontWeight={600}>
              Exportar
            </Typography>
          </IconButton>
        </Box>
      )}
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <DetailsSummary />
        </Grid>
        <Grid item xs={6}>
          {AmountSummary()}
        </Grid>
      </Grid>
    </div>
  );
};

export default PayOutSummary;
